import client from './api-client';

export const getConfiguracionForm13 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form13: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboTipoGestion = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboTipoGestion: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboAmbitoGestion = async(query) => {
    try {
        
        const response = await client.get(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboCAmbitoGestion: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboHitos = async(query) => {
    try {
        
        const response = await client.get(`cfg-trazabilidad?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboHitos: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const cambiarTipoGestion = async(file) => {
    try {
        
        const response = await client.post('caso/cambio-gestion', file);
        if (response.status === 200 && response.data.code === 1) {
            return {respuestaCambiandoGestion: response.data};
        } else {
            return {respuestaCambiandoGestion: response.data};
        }

    } catch(error){
        throw error;
    }
}